//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderLineMs', {
//        templateUrl: 'views/components/views/orderLineMs/orderLineMs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'orderLineMsService', function ($stateParams, orderLineMsService) {
//            const vm = this;
//            let argType = $stateParams.argtype;
//            let headNo = $stateParams.headno;
//            let lineNo = $stateParams.lineno;
            
//            vm.model = {
//                filterValueButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filtervalue = '' }
//                ],
//                setting: {},
//                itemsListSelectModels: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await orderLineMsService.getSetting({
//                    argtype: argType,
//                    headno: headNo,
//                    lineno: lineNo
//                }))[0];
//            }
            
//            async function loadSelectModels() {
//                vm.model.itemsListSelectModels = await orderLineMsService.listSelectModels(vm.model.setting);
//            }
            
//            vm.$onInit = async function () {
//                await loadSetting();
//                loadSelectModels();
//            }
//        }]
//    });
//})();
